import i18n from '../i18n';
import { continuationSearch } from './authHandoff';
import { apiFetch, setStoredSessionToken } from './apiClient';

export const logout = async (options = {}) => {
  try {
    const response = await apiFetch('/auth/logout', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({}),
    });
    if (!response.ok) throw new Error('Logout failed');
    setStoredSessionToken('');
    for (const domain of ['', '; Domain=noteician.com', '; Domain=.noteician.com']) {
      document.cookie = `userToken=; Max-Age=0; Path=/${domain}; SameSite=None; Secure`;
    }
    window.location.replace(options.preserveIntent === true ? `/${continuationSearch()}` : `/?lang=${encodeURIComponent(i18n.language)}`);
  } catch (_) {
    // A failed revocation must not look like a successful sign out.
    window.alert(i18n.t('authModern.errors.logout'));
  }
};
